import { z } from "zod";
import { dateSchema } from "@/types/schemas/date";

export const meterReadingsSchema = z.object({
  id: z.number().nullable().default(null),
  maxReadingDate: dateSchema,
  maxState: z.number().nullable().default(null),
  maxStateHigh: z.number().nullable().default(null),
  maxStateLow: z.number().nullable().default(null),
  minReadingDate: dateSchema,
  minState: z.number().nullable().default(null),
  minStateHigh: z.number().nullable().default(null),
  minStateLow: z.number().nullable().default(null),
  readingDate: dateSchema,
  readingDateHigh: dateSchema,
  readingDateLow: dateSchema,
  readingType: z.string().nullable().default(null),
  serNr: z.string().nullable().default(null),
  state: z.number().nullable().default(null),
  stateHigh: z.number().nullable().default(null),
  stateLow: z.number().nullable().default(null),
  tariffType: z.string().nullable().default(null),
  estimation: z.boolean().default(false),
});
